<!-- eslint-disable -->
<template>
  <div class="pa-4">
    <!-- Loading -->
    <div v-if="loading" class="text-center py-8">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <!-- Groups Table -->
    <v-table v-else>
      <thead>
        <tr>
          <th>{{ $t('admin.groupName') }}</th>
          <th>{{ $t('admin.type') }}</th>
          <th>{{ $t('admin.creator') }}</th>
          <th>{{ $t('admin.members') }}</th>
          <th>{{ $t('admin.posts') }}</th>
          <th>{{ $t('admin.created') }}</th>
          <th>{{ $t('admin.actions') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="group in groups" :key="group.groupId">
          <td>
            <div class="font-weight-medium">{{ group.groupName }}</div>
            <div class="text-caption text-grey text-truncate" style="max-width: 200px;">
              {{ group.groupDescription }}
            </div>
          </td>
          <td>
            <v-chip
              :color="group.isPublic ? 'success' : 'warning'"
              size="small"
            >
              <v-icon start size="small">{{ group.isPublic ? 'mdi-earth' : 'mdi-lock' }}</v-icon>
              {{ group.isPublic ? $t('admin.public') : $t('admin.private') }}
            </v-chip>
          </td>
          <td>{{ group.creatorDisplayName || group.creatorUsername }}</td>
          <td>{{ group.memberCount }}</td>
          <td>{{ group.postCount }}</td>
          <td>{{ formatDate(group.created_at) }}</td>
          <td>
            <v-btn
              icon
              variant="text"
              size="small"
              :to="`/groups/${group.groupId}`"
            >
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </td>
        </tr>
      </tbody>
    </v-table>

    <!-- Empty state -->
    <v-alert v-if="!loading && groups.length === 0" type="info">
      {{ $t('admin.noGroups') }}
    </v-alert>
  </div>
</template>

<script setup>
/* eslint-disable */
import { ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import api from '../../services/api'

const emit = defineEmits(['viewGroupPosts'])

const { locale } = useI18n()

const groups = ref([])
const loading = ref(false)

const loadGroups = async () => {
  loading.value = true
  try {
    const response = await api.get('/admin/groups')
    groups.value = response.data.groups || []
  } catch (error) {
    console.error('Failed to load groups:', error)
  } finally {
    loading.value = false
  }
}

const formatDate = (dateStr) => {
  if (!dateStr) return ''
  return new Date(dateStr).toLocaleDateString(locale.value)
}

const viewGroupPosts = (group) => {
  emit('viewGroupPosts', group.groupId)
}

onMounted(() => {
  loadGroups()
})
</script>